var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleteBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C8.96 0 0 8.96 0 20C0 31.04 8.96 40 20 40C31.04 40 40 31.04 40 20C40 8.96 31.04 0 20 0ZM19.9998 36.0001C11.1798 36.0001 3.99976 28.8201 3.99976 20.0001C3.99976 11.18 11.1798 4.00005 19.9998 4.00005C28.8198 4.00005 35.9998 11.18 35.9998 20.0001C35.9998 28.8201 28.8198 36.0001 19.9998 36.0001ZM16.0001 24.34L27.7601 12.58C28.5401 11.8 29.8201 11.8 30.6001 12.58C31.3801 13.36 31.3801 14.62 30.6001 15.4L17.4201 28.58C16.6401 29.36 15.3801 29.36 14.6001 28.58L9.42006 23.4C8.64006 22.62 8.64006 21.36 9.42006 20.58C9.79372 20.2055 10.301 19.995 10.8301 19.995C11.3591 19.995 11.8664 20.2055 12.2401 20.58L16.0001 24.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteBig);
export default __webpack_public_path__ + "static/media/complete_big.a1ff040b.svg";
export { ForwardRef as ReactComponent };